export default function onlyNumber(event) {
  const reg = /\d/;
  if (!reg.test(event.key)) {
    return event.preventDefault();
  }
}
